module.exports = flarum.core.compat['forum/dianLiang/PushFrontModal'];